export const CAMPAIGN_STATUS_LABELS: Record<string, string> = {
  draft: "Черновик",
  scheduled: "Запланирована",
  sending: "Отправляется",
  sent: "Отправлена",
  cancelled: "Отменена",
  failed: "Ошибка",
};

export function isPushCampaignEditable(status: string | null | undefined): boolean {
  return status === "draft" || status === "scheduled";
}

export const RECIPIENT_STATUS_LABELS: Record<string, string> = {
  pending: "В очереди",
  sent: "Отправлено",
  delivered: "Доставлено",
  failed: "Не доставлено",
  skipped: "Пропущен",
};

export const SKIP_REASON_LABELS: Record<string, string> = {
  client_deleted: "Клиент удалён",
  no_active_token: "Нет активного токена",
  promotions_disabled: "Отключены промо-уведомления",
};

export const LINK_KINDS = [
  "none",
  "service_center",
  "closest",
  "bookings",
] as const;

export type PushCampaignLinkKind = (typeof LINK_KINDS)[number];

export const AUDIENCE_MODES = ["all_matching", "client_uuids"] as const;

export type PushCampaignAudienceMode = (typeof AUDIENCE_MODES)[number];

export const LINK_KIND_LABELS: Record<PushCampaignLinkKind, string> = {
  none: "Просто открыть приложение",
  service_center: "Конкретный сервис",
  closest: "Ближайший сервис",
  bookings: "Мои записи",
};

export const BUSINESS_TYPE_LABELS: Record<string, string> = {
  any: "Любой",
  car_wash: "Автомойка",
  tire_service: "Шиномонтаж",
};

export const FUNNEL_STAGES = [
  "opened",
  "service_viewed",
  "slot_selected",
  "checkout_started",
  "booking_created",
  "booking_paid",
  "booking_completed",
] as const;

export type FunnelStage = (typeof FUNNEL_STAGES)[number];

export const FUNNEL_STAGE_LABELS: Record<FunnelStage, string> = {
  opened: "Открыли",
  service_viewed: "Просмотр сервиса",
  slot_selected: "Выбран слот",
  checkout_started: "Начали оформление",
  booking_created: "Создали запись",
  booking_paid: "Оплатили",
  booking_completed: "Завершили визит",
};

export const CAMPAIGN_STATUS_FILTER_ALL = "all";

export const CAMPAIGN_STATUS_FILTER_OPTIONS = [
  { value: CAMPAIGN_STATUS_FILTER_ALL, label: "Все статусы" },
  { value: "draft", label: CAMPAIGN_STATUS_LABELS.draft },
  { value: "scheduled", label: CAMPAIGN_STATUS_LABELS.scheduled },
  { value: "sending", label: CAMPAIGN_STATUS_LABELS.sending },
  { value: "sent", label: CAMPAIGN_STATUS_LABELS.sent },
  { value: "cancelled", label: CAMPAIGN_STATUS_LABELS.cancelled },
  { value: "failed", label: CAMPAIGN_STATUS_LABELS.failed },
];
